"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateElementHeight = calculateElementHeight;
exports.getElementHeight = getElementHeight;

var _detectNode = _interopRequireDefault(require("detect-node"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-env browser */
function calculateElementHeight(element) {
  return Math.max(element.scrollHeight, element.offsetHeight, element.clientHeight);
}

function getElementHeight(element) {
  if (_detectNode["default"]) {
    return 0;
  }

  if (element instanceof Window) {
    return Math.max(calculateElementHeight(element.document.body), calculateElementHeight(element.document.documentElement));
  }

  return calculateElementHeight(element);
}